import React from 'react';
import PropTypes from 'prop-types';

function FormSpinner({ spinnerRef }) {
    return (<div ref={spinnerRef} className='page-spinner is-visible'></div>);
}

FormSpinner.propTypes = {
    spinnerRef: PropTypes.object
};

export default FormSpinner;
